import { render } from "./TableChart.vue?vue&type=template&id=3f50ea70"
import script from "./TableChart.vue?vue&type=script&lang=js"
export * from "./TableChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__